var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.4286 13.3878C12.3946 13.8231 12.1905 14.1088 11.7483 14.1088C11.2721 14.1088 11.034 13.7619 11.034 13.3129V13.1565C11.034 12.2857 11.4558 11.7075 12.3401 11.1769C13.1633 10.6803 13.4558 10.2721 13.4558 9.60544C13.4558 8.80272 12.8367 8.2517 11.932 8.2517C11.1088 8.2517 10.5646 8.65986 10.3469 9.40136C10.2109 9.82313 10 9.97279 9.65986 9.97279C9.2381 9.97279 9 9.72109 9 9.30612C9 9.01361 9.06122 8.77551 9.18367 8.5102C9.59864 7.57143 10.6327 7 11.9932 7C13.7687 7 15 8.04082 15 9.54422C15 10.5986 14.4694 11.3197 13.5714 11.8571C12.6939 12.3741 12.4626 12.7211 12.4286 13.3878ZM12.6463 16.1224C12.6463 16.619 12.2585 17 11.7483 17C11.2517 17 10.8571 16.619 10.8571 16.1224C10.8571 15.6258 11.2517 15.2449 11.7483 15.2449C12.2585 15.2449 12.6463 15.6258 12.6463 16.1224Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.9fa1b70a.svg";
export { ForwardRef as ReactComponent };